import { render } from "./ReleaseDetails.vue?vue&type=template&id=1dedf3be"
import script from "./ReleaseDetails.vue?vue&type=script&lang=js"
export * from "./ReleaseDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__